import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { testimonials } from '../../data/testimonials';
const ease = [0.23, 1, 0.32, 1] as const;
export function TestimonialsSection() {
  const [activeId, setActiveId] = useState(testimonials[0].id);
  const active = testimonials.find(t => t.id === activeId) ?? testimonials[0];
  return <section aria-labelledby="testimonials-title" className="w-full bg-cream py-24 md:py-32" data-id="element-107" data-mp="1srkdbhau4gpx">
      <div className="mx-auto max-w-7xl px-5 md:px-8" data-id="element-108" data-mp="2gho7yz61p64s">
        <div className="grid gap-6 lg:grid-cols-12" data-id="element-109" data-mp="2ld3j3jco4nxi">
          <h2 id="testimonials-title" className="font-serif text-5xl leading-[1] text-aloe-900 md:text-7xl lg:col-span-7" data-id="element-110" data-mp="27n01x6snbkex">
            Parce qu’ils en parlent <span className="italic text-sage" data-id="element-111" data-mp="2bnah9a2bvn6g">le mieux.</span>
          </h2>
          <p className="max-w-md self-end text-ink/70 lg:col-span-5" data-id="element-112" data-mp="2zdxrw33moqwp">
            Nos clients sont au centre de nos préoccupations et nous prenons l’ensemble de vos retours en considération.
          </p>
        </div>

        <div className="mt-16 grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-113" data-mp="15lkesyyq877u">
          <figure className="relative lg:col-span-8" aria-live="polite" data-id="element-114" data-mp="10m7p86gh0m1k">
            <span aria-hidden="true" className="block font-serif text-[8rem] leading-[0.6] text-leaf" data-id="element-115" data-mp="1falraf62c6h2">
              “
            </span>
            <AnimatePresence mode="wait" data-id="element-116" data-mp="1aiub8ykj9j56">
              <motion.div key={active.id} initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -6
            }} transition={{
              duration: 0.22,
              ease
            }} data-id="element-117" data-mp="1ahsohwu5n87m">
                <blockquote className="mt-4 font-serif text-3xl leading-[1.2] text-aloe-900 md:text-[2.6rem]" data-id="element-118" data-mp="1y855dx7dofac">
                  {active.quote}
                </blockquote>
                <figcaption className="mt-8 text-sm font-semibold text-ink/70" data-id="element-119" data-mp="3ux7fwo3vnkh">— {active.author}</figcaption>
              </motion.div>
            </AnimatePresence>
          </figure>

          <ul className="lg:col-span-4" aria-label="Choisir un avis" data-id="element-120" data-mp="1yyv4h0pg8zgz">
            {testimonials.map(t => {
            const selected = t.id === activeId;
            return <li key={t.id} data-id="element-121" data-mp="27z9si7tssso6">
                  <button type="button" aria-pressed={selected} onClick={() => setActiveId(t.id)} className={`flex w-full items-center justify-between gap-4 border-t border-ink/10 py-4 text-left transition-colors duration-150 ease-out ${selected ? 'text-aloe-900' : 'text-ink/50 hover:text-ink/80'}`} data-id="element-122" data-mp="27z0bvaun7xv5">
                    <span data-id="element-123" data-mp="2rpdiuxvmin9p">
                      <span className="block text-sm font-semibold" data-id="element-124" data-mp="2vombfzexgf3o">{t.author}</span>
                      <span className="block text-sm" data-id="element-125" data-mp="2vqoycaks9s46">{t.short}</span>
                    </span>
                    <span aria-hidden="true" className={`h-2 w-2 shrink-0 rounded-full transition-colors duration-150 ease-out ${selected ? 'bg-leaf' : 'bg-ink/15'}`} data-id="element-126" data-mp="30m49gurep9ww" />
                  </button>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}